<template>
  <div class="" v-if="data && data.amount_introduce">
    <img
      class="image"
      v-if="data.amount_introduce_type == 2"
      :src="data.amount_introduce"
      alt=""
    />
    <div v-else class="text">{{ data.amount_introduce }}</div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {}
  },
  created() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.image {
  width: 100%;
  margin-top: 10px;
}

.text {
  padding: 20px;
  font-size: 10px;
  color: #94601d;
  line-height: 16px;
}
</style>
